import React, { useState } from 'react';
import { Button, Form, Input, message, DatePicker } from 'antd';
import { generateReciept } from './pdfUtils';
import moment from 'moment';

function ReceiptGenerator() {
    const [form] = Form.useForm();
    const [receiptNo, setReceiptNo] = useState('1');

    const disabledDate = (current) => {
        return current && current > moment().endOf('day');
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            const dateString = values.date.format('DD-MM-YYYY');

            const modifiedPdfBytes = await generateReciept({
                name: values.name,
                secondLine: values.second_line || "",
                amount: values.amount,
                being: values.being || "",
                mode: values.mode || "",
                date: dateString,
                receiptNo: receiptNo
            });

            // Create a blob and download the modified PDF
            const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${values.name}_receipt.pdf`;
            document.body.appendChild(a);

            // Trigger download
            a.click();

            // Cleanup
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            message.success('Receipt generated successfully!');
        } catch (error) {
            message.error('Error generating receipt');
            console.error(error);
        }
    };

    const validateNumber = (rule, value, callback) => {
        if (isNaN(value)) {
            callback('Please enter a valid number');
        } else {
            callback();
        }
    };

    const handleReceiptNoChange = (e) => {
        setReceiptNo(e.target.value);
    };

    return (
        <div style={{ padding: 20, maxWidth: 600, margin: '0 auto' }}>
            <h1>Receipt Generator</h1>
            <Form
                layout='vertical'
                form={form}
                initialValues={{
                    date: moment(),
                    receipt_no: receiptNo,
                }}
            >
                <Form.Item
                    label='Receipt No.'
                    name='receipt_no'
                    rules={[{ required: true, message: 'Please enter a receipt number' }]}>
                    <Input placeholder='Enter Receipt Number' onChange={handleReceiptNoChange} value={receiptNo} />
                </Form.Item>

                <Form.Item
                    label='Name'
                    name='name'
                    rules={[{ required: true, message: 'Please enter name' }]}>
                    <Input placeholder='Enter Name' />
                </Form.Item>

                <Form.Item
                    label='Address'
                    name='second_line'>
                    <Input placeholder='Enter Address' />
                </Form.Item>

                <Form.Item
                    label='Amount'
                    name='amount'
                    rules={[
                        { required: true, message: 'Please enter amount' },
                        { validator: validateNumber }
                    ]}>
                    <Input placeholder='Enter Amount' />
                </Form.Item>

                 <Form.Item
                     label='Being'
                     name='being'>
                     <Input placeholder='Being' />
                 </Form.Item>

                 <Form.Item
                     label='Mode'
                     name='mode'>
                     <Input placeholder='Enter Mode' />
                 </Form.Item>

                <Form.Item
                    label='Date'
                    name='date'
                    rules={[{ required: true, message: 'Please select a date' }]}>
                    <DatePicker
                        disabledDate={disabledDate}
                        format="DD-MM-YYYY" />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" onClick={handleSubmit}>
                        Generate Receipt
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}

export default ReceiptGenerator;